export const CALENDAR_IMPORT_STATE = {
  WAITING_FOR_FILE: 'waiting-for-file',
  BEGIN_IMPORT: 'begin-import',
  IMPORTING: 'importing',
  IMPORTED: 'imported',
  DISCARDING: 'discarding',
} as const

export type CalendarImportState = ValueOf<typeof CALENDAR_IMPORT_STATE>

export const CALENDAR_IMPORT_RESULT_TYPE = {
  ERROR: 'error',
  SUCCESS: 'success',
} as const

export const CALENDAR_IMPORT_MICROSERVICE_STATUS = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILURE: 'FAILURE',
  SUCCESS: 'SUCCESS',
  DISCARD_DONE: 'DISCARD_DONE',
  DISCARD_IN_PROGRESS: 'DISCARD_IN_PROGRESS',
  DISCARD_FAILURE: 'DISCARD_FAILURE',
} as const

export const CALENDAR_IMPORT_ALLOWED_FILE_MAX_SIZE = 12582912

export const ERROR_MESSAGE_TYPE = {
  WRONG_FILE_SIZE: 'wrong-file-size',
  WRONG_FILE_FORMAT: 'wrong-file-format',
  FILE_CORRUPTED: 'file-corrupted',
  FAILED_IMPORT: 'failed-import',
  DISCARD_FAILED: 'discard-failed',
  UNKNOWN: 'unknown',
} as const

export type CalendarImportErrorMessageType = ValueOf<typeof ERROR_MESSAGE_TYPE>

export const SUCCESS_MESSAGE_TYPE = {
  DISCARD_COMPLETED: 'discard-completed',
} as const

export const CALENDAR_IMPORT_CONFIGURATION_DEFAULT = {
  supported_file_extensions: ['ics'],
  import_tutorial_url: null as string | null,
}
